import { useState } from 'react';
import { Button } from '@/components/Button';
import { FormTextarea } from '@/components/FormTextarea';
import { useToast } from '@/hooks/useToast';

interface DecisionActionsProps {
    primaryLabel: string;
    onPrimary: () => Promise<unknown>;
    onReject: (note: string) => Promise<unknown>;
    rejectLabel?: string;
    busy: boolean;
    primaryDisabled?: boolean;
    helper?: string;
}

export function DecisionActions({ primaryLabel, onPrimary, onReject, rejectLabel = 'Recusar', busy, primaryDisabled = false, helper }: DecisionActionsProps) {
    const toast = useToast();
    const [rejecting, setRejecting] = useState(false);
    const [note, setNote] = useState('');

    async function confirmReject() {
        if (note.trim() === '') {
            toast.error('Escreva o motivo', 'Ele aparece para o colaborador.');
            return;
        }
        try {
            await onReject(note.trim());
            setRejecting(false);
            setNote('');
        } catch {
            return;
        }
    }

    if (rejecting) {
        return (
            <div className="space-y-3 border-t border-raro-gray-200 pt-5">
                <FormTextarea label="Motivo da recusa" name="reject-note" value={note} onChange={event => setNote(event.target.value)} maxLength={500} showCharCount rows={3} required />
                <div className="flex justify-end gap-2">
                    <Button variant="ghost" onClick={() => { setRejecting(false); setNote(''); }} disabled={busy}>Voltar</Button>
                    <Button variant="danger" onClick={() => void confirmReject()} loading={busy}>Confirmar recusa</Button>
                </div>
            </div>
        );
    }

    return (
        <div className="space-y-3 border-t border-raro-gray-200 pt-5">
            {helper && <p className="text-xs text-raro-gray-500">{helper}</p>}
            <div className="grid gap-2 sm:grid-cols-2">
                <Button variant="outline" onClick={() => setRejecting(true)} disabled={busy}>{rejectLabel}</Button>
                <Button onClick={() => void onPrimary().catch(() => undefined)} loading={busy} disabled={primaryDisabled}>{primaryLabel}</Button>
            </div>
        </div>
    );
}
